import moment from 'moment';

// Structure for TimePickerRange state:
// value[0]: string - startTime
// value[1]: string - endTime
// value[2]: Object { label: string, value: string } - TimeZone

export function handleInitialTime() {
  const interval = 30 * 60 * 1000;
  return moment(Math.ceil(moment() / interval) * interval).format('hh:mm A');
}

export const parseValueToSelectTimeZone = data => {
  if (typeof data === 'object') {
    return data[2] && data[2].label ? data[2] : null;
  }
  return data || null;
};

export const parseValueToField = (data, isStartTime) => {
  if (typeof data === 'object') {
    return data[0] || data[1]
      ? convertTimeTo12HoursFormat(isStartTime ? data[0] : data[1])
      : null;
  }
  return data || null;
};

export const convertTimeTo24HoursFormat = time => {
  return moment(time, ['h:mm A']).format('HH:mm');
};

export const convertTimeTo12HoursFormat = time => {
  if (time && time.length > 5) return time;
  return moment(time, ['HH:mm']).format('h:mm A');
};

export function formatTimeRangeView(item) {
  if (!item[0] || !item[1]) return '-';
  return `${convertTimeTo12HoursFormat(item[0])} - ${convertTimeTo12HoursFormat(
    item[1],
  )}, ${item[2].value}`;
}



// WEBPACK FOOTER //
// ./src/components/common/TimePickerRange/utils.js